import { useEffect } from "react";
import { scrollTo } from "@lib/util/scroll-ops";
const useAppearInsideScreen = (ref, isOpenState) => {
  useEffect(() => {
    if (isOpenState) {
      // Timeout allows the ref to be set, wo timeout at the time the effect runs the ref is null
      setTimeout(() => {
        if (ref.current) {
          // Calculate the bottom position of the div
          const divBottom = ref.current.getBoundingClientRect().bottom;

          // Calculate the height of the viewport
          const viewportHeight = window.innerHeight;

          // Calculate the current scroll position
          const scrollTop = document.documentElement.scrollTop;

          // Calculate the bottom position of the screen
          const screenBottom = scrollTop + viewportHeight;

          // Check if the bottom of the div is below the bottom of the screen
          if (divBottom > screenBottom) {
            var _document$getElementB;
            // Calculate the amount to scroll
            const scrollAmount = divBottom - screenBottom;
            const currentScroll = ((_document$getElementB = document.getElementById('app')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.scrollTop) || 0;

            // Scroll the window
            scrollTo(currentScroll + scrollAmount);
          }
        }
      }, 100);
    }
  }, [isOpenState]);
};
export default useAppearInsideScreen;